module.exports = __webpack_public_path__ + "static/media/story_3.1615dddc.png";